import {
  WorkflowConfigInputModel,
  WorkflowOrderInputModel,
  WorkflowOrderStepStatus,
  WorkflowOrderType,
} from '@ail/orders-api'
import './WorkflowOrderListEdit.scss'

export function WorkflowOrderListEdit(props: {
  config: WorkflowConfigInputModel
  selectedOrderIdx: number
  onChange: (value: WorkflowConfigInputModel) => void
  onSelectedOrderIdxChange: (idx: number) => void
}) {
  const addOrder = () => {
    const newOrder: WorkflowOrderInputModel = {
      type: WorkflowOrderType.Suppliers,
      form: {
        name: 'New order',
        status: WorkflowOrderStepStatus.New,
        fields: [],
        active: false,
        notifyTenant: false,
        enableWhenDone: [],
        enableWhen: {},
      },
      conditions: {},
    }
    props.onChange({ ...props.config, orders: [...props.config.orders, newOrder] })
  }

  return (
    <table className="workflow-order-list-edit" border={1}>
      <tbody>
        <tr>
          {props.config.orders.map((o, i) => (
            <th
              key={i}
              onClick={() => props.onSelectedOrderIdxChange(i)}
              style={{ color: i === props.selectedOrderIdx ? 'green' : 'black' }}
            >
              {o.form.name}
            </th>
          ))}
          <th onClick={addOrder} style={{ padding: '5px', cursor: 'pointer' }}>
            <i className="icon-add" style={{ cursor: 'pointer', color: 'green' }} />
          </th>
        </tr>
      </tbody>
    </table>
  )
}
